import React from 'react';
import PropTypes from 'prop-types';

import '../styles/KeyboardMenu.css';
import {ReactComponent as BackIcon} from '../icons/back-icon.svg';
import {ReactComponent as CancelIcon} from '../icons/cancel-icon.svg';

const icons = {
    back: <BackIcon className="Icon-topbar" />,
    cancel: <CancelIcon className="Icon-topbar" />,
}

const KeyboardMenu = ({ name, title }) => {
    const keys = [...".@-/:;!?()[]<>*#,+=$%&'\"{}abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789\\`_|~"];
    return (
      <div className="Keyboard-container">
        <div className="Keyboard-title">{name}</div>
        <div className="Keyboard-wrap">
          <div className="Keyboard-output">{title}</div>
          <ul className="Keyboard">
            {keys.map(el => <li key={el} className="Keyboard-item">{el}</li>)}
          </ul>
          <div className="Keyboard-buttons">
            <div className="Keyboard-button">
              {`${title.length}/8`}
            </div>
            <div className="Keyboard-button Button-active">OK</div>
            <div className="Keyboard-button">{icons.cancel}{icons.back}</div>
          </div>
        </div>
      </div>
    );
  };
  
KeyboardMenu.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default KeyboardMenu;
  